import {
    isAbTestVariant,
    getAbTestTrackingData,
} from 'dibs-buyer-layout/exports/clientABTestHelpers';
import tracking from 'dibs-tracking';

const PDP_FREE_SHIPPING_TESTS_NAME = 'PDP_FREE_SHIPPING_TESTS';

export function showPdpFreeShippingTestVariant() {
    return isAbTestVariant(document.cookie, PDP_FREE_SHIPPING_TESTS_NAME);
}

function trackPdpFreeShippingTest(pageType) {
    const trackingData = getAbTestTrackingData(document.cookie, PDP_FREE_SHIPPING_TESTS_NAME);
    tracking.trackAbTestEvent(trackingData, pageType);
}

export function trackPdpFreeShippingTestForDesktop() {
    trackPdpFreeShippingTest('PDP_DESKTOP');
}

export function trackPdpFreeShippingTestForMobile() {
    trackPdpFreeShippingTest('PDP_MOBILE');
}

export function trackPdpFreeShippingDisplay(itemId) {
    tracking.trackEvent({
        category: 'product',
        action: 'free shipping displayed',
        label: itemId,
    });
}
